import {Box} from "@mui/material";
import ourApproach from '../assets/our-approach.png';
import familyEngagement from '../assets/family-engagement.png';
// import accreditation from '../assets/accreditation.png';
import logo from '../assets/logo-wide.svg';
import flare from '../assets/flare/rip-top.svg'

import ContentTile from "../assets/components/ContentTile.tsx";
import ResponsiveAppBar from "../assets/components/ResponsiveAppBar.tsx";
import Footer from "./Footer.tsx";
import ContactFooter from "./ContactFooter.tsx";
import VideoSlideshow from "../assets/components/VideoSlideshow.tsx";

import Thumb1 from "../assets/videos/1_heather_thumb.jpg";
import Thumb2 from "../assets/videos/2_alexa_3_thumb.jpg";
import Thumb3 from "../assets/videos/3_mary_thumb.jpg";
import Thumb4 from "../assets/videos/4_claudia_thumb.jpg";
import Thumb5 from "../assets/videos/5_megan_thumb.jpg";
import Thumb6 from "../assets/videos/6_alexa_2_thumb.jpg";
import Thumb7 from "../assets/videos/7_nancy_thumb.jpg";
import Thumb8 from "../assets/videos/8_mirel_thumb.jpg";
import Thumb9 from "../assets/videos/9_laura_thumb.jpg";
import Thumb10 from "../assets/videos/10_alexa_1_thumb.jpg";
import Thumb11 from "../assets/videos/11_callie_thumb.jpg";

function OurStory() {
    return (
        <>
            <Box sx={{}}>
                <ResponsiveAppBar/>
                <Box className={'hero'}>
                    <Box sx={{maxHeight: {xs: '70vh', sm: '90vh'}, display:'flex', justifyContent:'center', placeItems:'baseline', alignItems:'center', overflow:'hidden'}}>
                        <video className={'hero-video'} autoPlay style={{ minHeight:'50vh'}} playsInline loop muted>
                            <source src="https://d24989mqjiw1g5.cloudfront.net/prod_hero.mp4" type="video/mp4"/>
                            Your browser does not support the video tag.
                        </video>
                        <Box sx={{position:'absolute', top:0, left:0, width:'100vw', height:'100vh', background:'black', opacity:'0.2'}}></Box>
                    </Box>
                    <Box sx={{position:'absolute', top:0, left:0, width:'100%', height:'100%', display:'flex', justifyContent:'center', alignItems:'center', overflow:'hidden'}}>
                        <img style={{width:'80%', maxWidth:'330px'}} src={logo} alt={"Prodigy Learning"}/>
                    </Box>
                    <Box component={"img"} sx={{position:'absolute', 'bottom':-1, 'left':-10, width:{xs: '200vw', sm: '150vw', md:'110'}, objectFit:'cover', maxHeight:200, objectPosition:'top',}} alt={"ripped paper"} src={flare} />
                </Box>
                <ContentTile
                    id={"our-approach"}
                    header={"OUR APPROACH"}
                    subtitle={"Reggio Inspired Learning"}
                    body={`Prodigy Early Learning Centers are modeled on the
                        developmental and
                        constructivist approaches inspired by the work of the most influential child
                        psychologists in history: Maria Montessori, Jean Piaget, Lev Vygotsky, and Loris
                        Malaguzzi. We are committed to the development of the whole child, instilling in
                        them a
                        robust sense of self-confidence to navigate new experiences and the challenges of a
                        rapidly evolving world.
                        \\n\\n
                        In the constructivist approach to teaching and learning, children are viewed as
                        unique
                        learners. Educators focus on observing and listening to children to understand their
                        interests, needs, and learning styles which enables teachers to tailor learning
                        experiences to the unique abilities and preferences of each child.`}
                    ImageComponent={<img src={ourApproach} alt={'Our Approach'}/>}
                    reverse={true}
                />
                <ContentTile
                    id={"meet-our-team"}
                    header={"MEET OUR TEAM & FAMILIES"}
                    subtitle={""}
                    // body={``}
                    isSlideshow={false}
                    ImageComponent={<VideoSlideshow videos={ [
                        { id: '1', title: 'heather', url: "https://d24989mqjiw1g5.cloudfront.net/heather.mp4", thumbnail: Thumb1 },
                        { id: '2', title: 'alexa_3', url: "https://d24989mqjiw1g5.cloudfront.net/alexa_3.mp4", thumbnail: Thumb2 },
                        { id: '3', title: 'mary', url: "https://d24989mqjiw1g5.cloudfront.net/mary.mp4", thumbnail: Thumb3 },
                        { id: '4', title: 'callie', url: "https://d24989mqjiw1g5.cloudfront.net/callie.mp4", thumbnail: Thumb11 },
                        { id: '5', title: 'claudia', url: "https://d24989mqjiw1g5.cloudfront.net/claudia.mp4", thumbnail: Thumb4 },
                        { id: '6', title: 'megan', url: "https://d24989mqjiw1g5.cloudfront.net/megan.mp4", thumbnail: Thumb5 },
                        { id: '7', title: 'alexa_2', url: "https://d24989mqjiw1g5.cloudfront.net/alexa_2.mp4", thumbnail: Thumb6 },
                        { id: '8', title: 'nancy', url: "https://d24989mqjiw1g5.cloudfront.net/nancy.mp4", thumbnail: Thumb7 },
                        { id: '9', title: 'mirel', url: "https://d24989mqjiw1g5.cloudfront.net/mirel.mp4", thumbnail: Thumb8 },
                        { id: '10', title: 'laura', url: "https://d24989mqjiw1g5.cloudfront.net/laura.mp4", thumbnail: Thumb9 },
                        { id: '11', title: 'alexa_1', url: "https://d24989mqjiw1g5.cloudfront.net/alexa_1.mp4", thumbnail: Thumb10 },
                    ]}/>}
                />

                <ContentTile
                    id={"family-engagement"}
                    header={"FAMILY ENGAGEMENT"}
                    subtitle={"Building School Community"}
                    body={`The foundation of our philosophy and curriculum is built upon the partnership of family, 
                    community, and school. Involving children in school-wide events and celebrating their work throughout 
                    the larger school community exposes them to a broader scope of teachers and role models. It instills 
                    and emphasizes a sense of community and belonging from a young age. Celebrating their work and achievements 
                    also serves to underscore the importance and value of education in their lives and encourage them to
                     pursue new goals.
                        \\n\\n
                        Prodigy Early Learning takes pride in building meaningful relationships with our families. On 
                        several special occasions throughout the year, we host community events open to parents and 
                        families, which strengthens the link between children’s school lives and their support systems 
                        outside of the educational realm.`}
                    ImageComponent={<img src={familyEngagement} alt={'Family Engagement'}/>}
                    reverse={true}
                />
                <ContentTile
                    id={"learning-environment"}
                    header={"LEARNING ENVIRONMENT"}
                    subtitle={""}
                    body={`Our learning environments are recognized as the third teacher and considered an 
                    essential aspect of learning. Classrooms are carefully curated to be inviting, flexible, and
                     organized, promoting exploration and collaboration. Natural materials, open spaces, and purposeful 
                     displays stimulate curiosity and creativity. Teachers act as guides allowing children to solve problems
                      and navigate the different aspects of project-based lessons in their environments. Observing children
                       in action gives teachers perspective into the students’ strengths, areas in need of improvement, 
                       emotional development, and their likes and dislikes.`}
                    isSlideshow={true}
                    ImageComponent={<div></div>}
                />
                <ContactFooter/>
                <Footer/>


            </Box>


        </>
    );
}

export default OurStory
